
<div class="spinner d-flex flex-column justify-content-center align-items-center vh-100">

    <div class="loading d-flex flex-column flex-md-row justify-content-center align-items-center vh-100">

        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        
    </div>

</div>